import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-2xl font-heading font-bold text-background-50">po18</Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              po18是深受用户喜爱的内容阅读平台，提供海量优质小说、漫画、轻小说等数字阅读内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</Link>
              <Link to="/category/yanqing" className="text-sm text-background-400 hover:text-background-100 transition-colors">分类浏览</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">关于我们</Link>
              <a href="https://www.po18.com" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-primary-400 hover:text-primary-300 transition-colors">进入po18 →</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-400">邮箱：support@po18.com</span>
              <span className="text-sm text-background-400">客服时间：7×24小时</span>
              <div className="flex gap-3 mt-2">
                <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2018-2026 po18阅读平台 版权所有
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}